<template>
    <span class="widget-icon">
        <i class="fas fa-angle-down" v-show="!isUp"></i>
        <i class="fas fa-angle-up" v-show="isUp"></i>
    </span>
</template>
<script>
    export default {
        props: {
            isUp: {
                type: Boolean,
                required: true
            }
        }
    }
</script>